
import { useEffect } from 'react';
import dynamic from 'next/dynamic';

const TrackingProvider = dynamic(() => Promise.resolve(() => {
  useEffect(() => {
    // 这里可以初始化 thinkingdata
    const initThinkingData = async () => {
      const thinkingdata = await import('thinkingdata-browser');
      // @ts-ignore
      thinkingdata.init({
        appId: '7d6d275740104c76ae9b65912baca30f',
        name: 'Ta',
        serverUrl: 'https://te.pinamania.com',
        autoTrack: {
          pageShow: true,
          pageHide: true,
        }
      });
      
      // 将 thinkingdata 挂载到 window 对象上，以便全局访问
      // @ts-ignore
      window.ta = thinkingdata;
    };
    
    initThinkingData();
  }, []);
  
  return null;
}), { ssr: false });

export default TrackingProvider;